import { Tooltip } from 'antd'
import React from 'react'

const RejectIcon = ({
  title="Reject"
}) => {
  return (
    <Tooltip title={title}>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 20C7.6 20 4 16.4 4 12C4 7.6 7.6 4 12 4C16.4 4 20 7.6 20 12C20 16.4 16.4 20 12 20Z"
          fill="#E35E50"
        />
        <path
          d="M16.0002 8.0002C15.6002 7.6002 15.0002 7.6002 14.6002 8.0002L12.0002 10.6002L9.40019 8.0002C9.00019 7.6002 8.4002 7.6002 8.0002 8.0002C7.6002 8.4002 7.6002 9.00019 8.0002 9.40019L10.6002 12.0002L8.0002 14.6002C7.6002 15.0002 7.6002 15.6002 8.0002 16.0002C8.2002 16.2002 8.5002 16.3002 8.7002 16.3002C8.9002 16.3002 9.20019 16.2002 9.40019 16.0002L12.0002 13.4002L14.6002 16.0002C14.8002 16.2002 15.1002 16.3002 15.3002 16.3002C15.5002 16.3002 15.8002 16.2002 16.0002 16.0002C16.4002 15.6002 16.4002 15.0002 16.0002 14.6002L13.4002 12.0002L16.0002 9.40019C16.4002 9.00019 16.4002 8.4002 16.0002 8.0002Z"
          fill="#E35E50"
        />
      </svg>
    </Tooltip>
  )
}

export default RejectIcon
